module.exports = __webpack_public_path__ + "img/reports.4e158195.svg";